<template>
  <div style="overflow-x: hidden">
    <!-- Estos componentes estaban hardcoeados pero no se podian mover -->
    <!-- <alarms-widget
      v-if="$can('waiting_alarms', 'Workspace')"
      :title="$t('grid.widgets.alarms.incoming_alarms.title')"
      :filters="{ filter: 'waiting' }"
      :id="`alarm-${tabId}`"
      :key="`alarm-${tabId}`"
      :parent-collapsed="isToolbarsCollapsed"
      :collapsible="true"
      :isOpen="true"
      location="sideBarRigth"
    />
    <alarms-widget
      v-if="$can('attending_alarms', 'Workspace')"
      :title="$t('grid.widgets.alarms.alarms_in_attention.title')"
      :filters="{ filter: 'attending' }"
      :id="`active-alarm-${tabId}`"
      :key="`active-alarm-${tabId}`"
      :parent-collapsed="isToolbarsCollapsed"
      :collapsible="true"
      :isOpen="true"
      location="sideBarRigth"
    /> -->
    <!-- Estos componentes estaban hardcoeados pero no se podian mover -->

    <!-- side bar right -->
    <draggable
      class="side-bar"
      :class="{ 'drag-over': isDragOverRight }"
      v-model="itemsRight"
      handle=".handle"
      :group="{ name: 'dashboard-widgets', pull: true, put: true }"
      item-key="id"
      @start="onStartRight"
      @end="onEndRight"
      @add="onAddRight"
      @move="onMoveRight"
      @dragenter.native.prevent="isDragOverRight = true"
      @dragleave.native.prevent="isDragOverRight = false"
      @drop.native.prevent="isDragOverRight = false"
    >
      <template v-for="item in itemsRight">
        <template
          v-if="
            item.componentName &&
            item.componentName === 'alarms-widget' &&
            shouldShowWidget(item)
          "
        >
          <component
            :is="item.componentName"
            :title="resolveWidgetTitle(item.title)"
            :filters="item.filters"
            :id="item.id"
            :key="item.id"
            :collapsible="item.collapsible"
            :isOpen="item.isOpen"
            :ignore-collapse="true"
            location="sideBarRigth"
            @widget-collapsed="onWidgetCollapse"
          />
        </template>

        <template
          v-else-if="
            item.componentName &&
            item.componentName === 'tenants-widget' &&
            shouldShowWidget(item)
          "
        >
          <component
            :is="item.componentName"
            :title="resolveWidgetTitle(item.componentName)"
            :id="item.id"
            :key="`tenants-widget-${item.id}`"
            :collapsible="item.collapsible"
            :isOpen="item.isOpen"
            :ignore-collapse="true"
            location="sideBar"
            @widget-collapsed="onWidgetCollapse"
          />
        </template>

        <template v-else-if="item.componentName && shouldShowWidget(item)">
          <component
            :is="item.componentName"
            :title="resolveWidgetTitle(item.componentName)"
            :id="item.id"
            :key="item.id"
            :collapsible="item.collapsible"
            :isOpen="item.isOpen"
            :ignore-collapse="true"
            location="bottomBar"
            @widget-collapsed="onWidgetCollapse"
          />
        </template>
      </template>
    </draggable>
    <!-- side bar right -->

    <!-- componente custom de alarmas -->
    <div
      v-if="alarmId && alarInfo"
      style="position: sticky; height: 100%; overflow-y: hidden"
      :class="[{ 'show-remove-btn': showRemoveBtn }]"
      id="alarm-data-container"
    >
      <div style="height: 40%" id="timeline-alarm-data">
        <div style="display: none" class="backdrop" id="backdrop"></div>
        <video class="w-100 h-100" controls v-if="video">
          <source :src="video.url" :type="video.mime_type" />
        </video>
        <cam-slot
          v-if="alarmId && cameraInfo.data && !video"
          :parent-id="tabId"
          :data="cameraInfo.data"
          :type="cameraInfo.type"
          :tab-info="tabInfo"
          :pos="1"
          :key="`${cameraInfo.type}:${cameraInfo.data.camera_proxy_id}`"
          :config="{ synced: false }"
          :style="`height: 100%;`"
        />
        <div class="remove-btn">
          <div>
            <feather-icon
              class="icon"
              icon="XIcon"
              size="48"
              @click="remove()"
              v-b-tooltip="'Cerrar'"
            />
            <feather-icon
              class="icon"
              :icon="!fullScreenEnabled ? 'Maximize2Icon' : 'Minimize2Icon'"
              size="40"
              @click="goFullScreen"
              v-b-tooltip="'Pantalla completa'"
            />
          </div>
        </div>
      </div>
      <info-slot
        v-if="alarmId && alarInfo"
        :data="alarInfo"
        :tab-info="tabInfo"
        style="height: 60%; position: relative"
      />
    </div>
    <!-- componente custom de alarmas -->
  </div>
</template>

<script>
import axios from "@axios";
import store from "@/store";
import { v4 as uuidv4 } from "uuid";
import CamSlot from "./layouts/slots/CamSlot.vue";
import InfoSlot from "./layouts/slots/InfoSlot";
import { SLOT_TYPES, SOURCES } from "@/config/layoutConfig";
import { ref, computed, watch } from "@vue/composition-api";
import { EventBus } from "@/libs/event-bus";
import draggable from "vuedraggable";
import AlarmsWidget from "./widgets/AlarmsWidget";
import TenantsWidget from "./widgets/TenantsWidget";
import LayoutsWidget from "./widgets/LayoutsWidget";
import WidgetsWidget from "./widgets/WidgetsWidget";
import ViewsWidget from "./widgets/ViewsWidget/ViewsWidget";
import VideoTourWidget from "./widgets/VideoTourWidget";
import ScriptsWidget from "./widgets/ScriptsWidget";
import VideoWallWidget from "./widgets/VideoWallWidget.vue";
import PagesWidget from "./widgets/PagesWidget";
import UnitGroupsWidget from "./widgets/UnitGroupsWidget";
import UserChartsWidget from "./widgets/UserChartsWidget";
import ChatWidget from "./widgets/ChatWidget";

export default {
  components: {
    CamSlot,
    InfoSlot,
    draggable,
    AlarmsWidget,
    TenantsWidget,
    LayoutsWidget,
    WidgetsWidget,
    ViewsWidget,
    VideoTourWidget,
    ScriptsWidget,
    VideoWallWidget,
    PagesWidget,
    UnitGroupsWidget,
    UserChartsWidget,
    ChatWidget,
  },
  methods: {
    onStartRight(evt) {
      store.commit("grid/setSidebarRightStartDragging", true);
      evt.originalEvent.dataTransfer.setData("from", "sidebarRight");
      this.isDragOverRight = true;
    },

    onEndRight() {
      store.commit("grid/setSidebarRightStartDragging", false);
      this.isDragOverRight = false;
      store.dispatch("user/updateUserConfig");
    },

    onAddRight(evt) {
      this.isDragOverRight = false;
    },

    onMoveRight(evt, originalEvent) {
      return true;
    },

    shouldShowRightWidget(item) {
      return true;
    },

    resolveRightWidgetTitle(item) {
      return item.title || item.componentName;
    },

    shouldShowWidget(item) {
      switch (item.componentName) {
        case "alarms-widget":
          // return true // TODO: remove this line
          if (item.id == 1) {
            return this.$can("waiting_alarms", "Workspace");
          } else if (item.id == 2) {
            return this.$can("attending_alarms", "Workspace");
          } else if (item.id === "user_alarms") {
            return this.$can("user_alarms", "Workspace");
          } else if (item.id === "in_review_alarms") {
            return this.$can("in_review_alarms", "Workspace");
          } else if (item.id === "in_maintenance_alarms") {
            return this.$can("in_maintenance_alarms", "Workspace");
          } else {
            return false;
          }

        case "tenants-widget": //
          return this.$can("facilities", "Workspace");

        case "layouts-widget": //
          return this.$can("layouts", "Workspace");

        case "views-widget": //
          return this.$can("views", "Workspace");

        case "video-tour-widget": //
          return this.$can("read", "VideoTour");

        case "widgets-widget": //
          return this.$can("widgets", "Workspace");

        case "video-wall-widget":
          return this.$can("read", "VideoWall");

        // case "scripts-widget":
        //   return this.$can('commands', 'Workspace');

        // case "pages-widget":
        //   return this.$can('web_pages', 'Workspace');

        // case "unit-groups-widget":
        //   return this.$can('facilities_group', 'Workspace');

        // case "user-charts-widget":
        //   return this.$can('charts', 'Workspace');

        case "chat-widget":
          if (this.user.enabled_chat && Number(window.__env.VUE_APP_ENABLED_CHAT)) {
            return this.$can("chat", "Workspace");
          }
          return false;

        default:
          return false;
      }
    },
    resolveWidgetTitle(title) {
      switch (title) {
        case "Alarmas en espera":
          return window.__env.VUE_APP_ENV == "banamex" ? "Alarmas por atender" : this.$t("grid.widgets.alarms.incoming_alarms.title");

        case "Alarmas en atención":
          return window.__env.VUE_APP_ENV == "banamex" ? "Alarmas en espera" : this.$t("grid.widgets.alarms.alarms_being_attended.title");

        case "Alarmas de usuario":
          return "Alarma en atención";

        case "Alarmas en revisión":
          return window.__env.VUE_APP_ENV == "banamex" ? "Maker Checker" : "Alarmas en revisión";

        case "tenants-widget":
          return this.$t("grid.widgets.units.title");

        case "layouts-widget":
          return this.$t("grid.widgets.layouts.title");

        case "views-widget":
          return this.$t("grid.widgets.views.title");

        case "video-tour-widget":
          return "Video Tour";

        case "widgets-widget":
          return this.$t("grid.widgets.widgets.title");

        case "video-wall-widget":
          return this.$t("grid.widgets.videowall.title");

        case "scripts-widget":
          return this.$t("grid.widgets.scripts.title");

        case "pages-widget":
          return this.$tc("pages.title", 2);

        case "unit-groups-widget":
          return this.$t("unit_groups.title");

        case "user-charts-widget":
          return this.$t("grid.widgets.charts.title");

        case "chat-widget":
          return "Chat";

        default:
          return title;
      }
    },
    onWidgetCollapse(data) {
      store.dispatch("grid/updateWidgetStatus", data);
    },
  },

  setup(_, context) {
    const tabId = uuidv4();
    const isDragOverRight = ref(false);
    const fullScreenEnabled = ref(false);
    const cameraHeight = ref(60);

    const video = ref(null);

    const tabInfo = computed(() => ({
      id: tabId,
      type: SLOT_TYPES.CAM_PA,
      slots: [],
    }));

    const cameraInfo = ref({
      type: SLOT_TYPES.CAM_RECORDED,
    });

    const alarInfo = ref(null);
    const alarmId = computed(() => store.state.grid.alarm_id);
    const alarmDataContainer = ref(null);
    const isToolbarsCollapsed = computed(
      () => store.state.psimConfig.isToolbarsCollapsedRight === 0
    );

    watch([alarmId], () => {
      if (alarmId.value) {
        refetchData();
      }
    });

    const refetchData = () => {
      alarInfo.value = null;

      axios
        .get(`${window.__env.VUE_APP_BASE_URL}/v1/alarm/${alarmId.value}`)
        .then((result) => {
          let data = result.data.data;
          alarInfo.value = data;
          alarInfo.value.data = {
            ...data,
            in_app_source: SOURCES.ALARM_VIEW,
          };

          const resolveCamera = (camera) => {
            return (
              camera.camera_proxy_id == data.detection_event_data?.id_camera_proxy ||
              camera.camera_proxy_id ==
                data.detection_event_data?.camera_data.camera.id_camera_proxy
            );
          };

          if (data.detection_event_data) {
            cameraInfo.value.data = JSON.parse(
              JSON.stringify(data.cameras.find(resolveCamera))
            );
            cameraInfo.value.data.camera = JSON.parse(
              JSON.stringify(cameraInfo.value.data)
            );

            video.value = data.detection_event_data.video
              ? data.detection_event_data.video
              : null;
          }
          // TODO: hard code for demo
          else if (
            alarInfo.value.alarm_acronym == "VD" &&
            alarInfo.value.id_router == 17088
          ) {
            let cameraInfoFilter = JSON.stringify(
              data.cameras.find((camera) => {
                return camera.camera_proxy_id == 48039;
              })
            );
            cameraInfo.value.data = JSON.parse(cameraInfoFilter);
            cameraInfo.value.data.camera = JSON.parse(cameraInfoFilter);
          } else {
            cameraInfo.value.data = JSON.parse(JSON.stringify(data.cameras[0]));
            cameraInfo.value.data.camera = JSON.parse(JSON.stringify(data.cameras[0]));
          }

          if (!cameraInfo.value.data.ts) {
            cameraInfo.value.data.ts = alarInfo.value.created;
          }

          tabInfo.value.slots.push({
            type: SLOT_TYPES.INFO,
            data,
          });

          tabInfo.value.slots.push(cameraInfo.value);
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const remove = () => {
      video.value = null;
      store.dispatch("grid/setAlarmId", null);
    };

    const goFullScreen = () => {
      if (!fullScreenEnabled.value) {
        fullScreenEnabled.value = true;
        cameraHeight.value = 80;
      } else {
        fullScreenEnabled.value = false;
        document.exitFullscreen();
        cameraHeight.value = 60;
      }
    };

    const onFullScreenChange = () => {
      if (!document.fullscreenElement) {
        fullScreenEnabled.value = false;
        cameraHeight.value = 60;
      } else {
        cameraHeight.value = 80;
      }
    };

    document.addEventListener("fullscreenchange", onFullScreenChange);

    let showRemoveBtn = computed(() => {
      return store.state.grid.showRemoveBtn;
    });

    EventBus.on("alarm:attending", (alarmId) => {
      if (alarmId == alarmId) {
        remove();
      }
    });

    EventBus.on("alarm:attended", (alarmId) => {
      if (alarmId == alarmId) {
        remove();
      }
    });

    EventBus.on("alarm:canceled", (alarmId) => {
      if (alarmId == alarmId) {
        remove();
      }
    });

    const itemsRight = computed({
      get() {
        return store.state.grid.sideBarRightItems;
      },
      set(value) {
        store.dispatch("grid/setSideBarRightItems", value);
      },
    });

    watch(
      itemsRight,
      (newVal) => {
        if (!newVal || newVal.length === 0) {
          store.commit("psimConfig/UPDATE_TOOLBARS_COLLAPSED_RIGHT", true);
        }
      },
      { deep: true }
    );

    return {
      tabId,
      tabInfo,
      alarmId,
      alarInfo,
      cameraInfo,
      remove,
      goFullScreen,
      fullScreenEnabled,
      showRemoveBtn,
      alarmDataContainer,
      cameraHeight,
      isToolbarsCollapsed,
      video,
      itemsRight,
      isDragOverRight,
    };
  },
};
</script>

<style lang="scss">
.side-bar {
  display: flex;
  flex-flow: column;

  .sortable-ghost {
    width: 50%;
    height: auto;
    opacity: 0.5;
    background: rgba(0, 145, 255, 0.81);
  }

  .sortable-chosen {
    width: 100%;
  }

  transition: all 0.2s ease;
  &.drag-over {
    background-color: rgba(0, 145, 255, 0.1);
    border: 2px solid #971f1e;
  }
}

.remove-btn {
  display: none;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(#000, 0.5);
  z-index: 999;

  .icon {
    color: #fff;
    cursor: pointer;
  }
}

.show-remove-btn {
  .remove-btn {
    display: flex;
  }
}
</style>
